import request from '@/utils/request';

export default {
    getItems: async({ dispatch, commit }, params) => {
        await request({ method: 'get', url: '/admin/brands', params })
            .then(res => {
                if (res.data) {
                    commit('PROCESS_RES', res.data);
                }
            }).catch(error => {
                const message = error.response && error.response.data && error.response.data.error;

                if (message) {
                    dispatch('alert/addMessage', {
                        message
                    }, { root: true });
                }
            });
    }
};

